import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import App from './App.js'
import store, { history } from './store'
import { Provider } from 'react-redux'

export default class Root extends Component {
  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Route path="/" component={App} />
        </ConnectedRouter>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Routes.js